import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Button, Col, Row, Space, Collapse } from 'antd'
import { ConfigData, DetailReq, UpdateReq } from 'Store/config/types'
import { selectActionEvent, selectDatas, selectDetailEvent } from 'Store/config/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { getConfigAPI, updateConfigAPI } from 'Store/config/api'
import LoadingView from 'Components/modal/LoadingView'
import HomePageLayout from 'Pages/Layout/PageLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { PrimaryButton } from 'Components/button'
import { formValidation, isFormError } from 'helpers/format'
import { clearEventAction } from 'Store/config/actions'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { AppInput } from 'Components/form'
import { cloneDeep } from 'lodash'
const { Panel } = Collapse

type Props = {} & ReduxProps

const PurchaseSetting: React.FunctionComponent<Props> = props => {
  const { currentUser, detail, detailEvent, event } = props
  const dispatch = useDispatch()
  const requireFeild = ['minimum_offline_stock', 'price_labels']
  const [confirmSaveDialog, setConfirmSaveDialog] = useState(false)
  const [formError, setFormError] = useState([] as string[])
  const [formData, setFormData] = useState({
    minimum_offline_stock: 0,
    price_labels: [],
  } as ConfigData)

  useEffect(() => {
    if (detail) {
      setFormData({
        minimum_offline_stock: detail.value.minimum_offline_stock,
        price_labels: detail.value.price_labels,
      })
    }
  }, [detail])

  useEffect(() => {
    setFormError([])
    onGetDetail()
  }, [])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const onGetDetail = (): void => {
    const req: DetailReq = {}
    dispatch(getConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onSave = () => {
    const req: UpdateReq = {
      id: detail?.id,
      merchant_id: detail?.merchant_id,
      value: formData,
      // value: {
      //   minimum_offline_stock: 10,
      //   price_labels: [
      //     {
      //       name: 'price_a',
      //       value: 'ราคา A',
      //     },
      //     {
      //       name: 'price_b',
      //       value: 'ราคา B',
      //     },
      //     {
      //       name: 'price_c',
      //       value: 'ราคา C',
      //     },
      //   ],
      // },
    }

    dispatch(updateConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onGetDetail()
    onCloseConfirmDailog()
  }

  const onClickSave = () => {
    if (!validateForm()) return
    onOpenConfirmDailog()
  }

  const onOpenConfirmDailog = () => {
    setConfirmSaveDialog(true)
  }

  const onCloseConfirmDailog = () => {
    setConfirmSaveDialog(false)
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    if (formData.minimum_offline_stock < 10) {
      error.push('minimum_offline_stock')
    }
    if (formData.price_labels) {
      formData.price_labels.forEach(item => {
        if (item.value.trim() === '') {
          error.push(item.name)
        }
      })
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const ConfirmSaveDailog = (
    <ConfirmDailog
      title="ยืนยันการบันทึกข้อมูล"
      description="คุณแน่ใจที่จะบันทึกข้อมูลหรือไม่?"
      confirmBtnTxt="บันทึก"
      isShow={confirmSaveDialog}
      handleOk={onSave}
      handleCancel={onCloseConfirmDailog}
    />
  )

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const onUpdateData = (val: any, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const onUpdatePrice = (val: string, index: number) => {
    const prices = cloneDeep(formData.price_labels)
    prices[index].value = val
    onUpdateData(prices, 'price_labels')
  }

  const onUpdateDescription = (val: string, index: number) => {
    const prices = cloneDeep(formData.price_labels)
    prices[index].description = val
    onUpdateData(prices, 'price_labels')
  }

  return (
    <HomePageLayout selected="purchase-setting" title="ตั้งค่าข้อมูลระบบจัดซื้อ" label={''}>
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="center" gutter={[8, 8]}>
        <Col span={24}>
          <BoxWrapper>
            <Collapse collapsible="header" ghost defaultActiveKey={['1']}>
              <Panel header="จัดการขั้นต่ำสต๊อกสินค้า" key="1">
                <Row>
                  <Col md={24} xs={24}>
                    <AppInput
                      name="minimum_offline_stock"
                      label="กำหนดจำนวนคงเหลือสินค้าขั้นต่ำของสต๊อกสินค้าขายออฟไลน์"
                      remark=" (ขั้นต่ำ 10 หน่วย)"
                      isRequired={true}
                      isError={isError('minimum_offline_stock')}
                      errorMsg="กำหนดจำนวนคงเหลือสินค้าขั้นต่ำของสต๊อกสินค้าขายออฟไลน์ ขั้นต่ำ 10 หน่วย"
                      value={formData.minimum_offline_stock}
                      onChange={onUpdateData}
                      type="number"
                      resProps={{ suffix: 'หน่วย', allowClear: false }}
                    />
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </BoxWrapper>
        </Col>
        <Col span={24}>
          <BoxWrapper>
            <Collapse collapsible="header" ghost defaultActiveKey={['1']}>
              <Panel header="กำหนดรูปแบบราคาสินค้า" key="1">
                {formData.price_labels.map((item, index) => {
                  return (
                    <Row gutter={[8, 8]} key={index}>
                      <Col md={10} xs={24}>
                        <AppInput
                          name={item.name}
                          label="ชื่อราคา"
                          placeHolder="ระบุชื่อราคา"
                          isRequired={true}
                          isError={item.value.trim() === ''}
                          value={item.value}
                          onChange={val => onUpdatePrice(val, index)}
                          resProps={{ allowClear: false }}
                        />
                      </Col>
                      <Col md={14} xs={24}>
                        <AppInput
                          name={item.name}
                          label="คำอธิบายเพิ่มเติม"
                          placeHolder="เช่น ขายเงินสด..."
                          isRequired={false}
                          isError={isError(item.name)}
                          value={item.description}
                          onChange={val => onUpdateDescription(val, index)}
                        />
                      </Col>
                    </Row>
                  )
                })}
              </Panel>
            </Collapse>
          </BoxWrapper>
        </Col>
      </Row>
      <br />
      <Row justify="center">
        <Col>
          <Space size="large">
            <MyButton type="primary" onClick={onClickSave}>
              บันทึกข้อมูล
            </MyButton>
            <PrimaryButton btnType="Cancel" text="ยกเลิก" onClick={onGetDetail} />
          </Space>
        </Col>
      </Row>
      {ConfirmSaveDailog}
    </HomePageLayout>
  )
}

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const MyButton = styled(Button)`
  height: 45px;
  border-radius: 5px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDatas(state),
    detailEvent: selectDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PurchaseSetting)
